export default {"src":"/_next/static/media/1.32622e77.svg","height":77,"width":84,"blurWidth":0,"blurHeight":0};